<template>
  <div class="w-full pl-4 pr-4 bg-white">
    <div
      class="w-full flex flex-col gap-3 bg-darkBlue py-3 pl-4 rounded-sm shadow pr-3"
    >
      <div class="flex items-end justify-between overflow-hidden">
        <div
          class="text-white font-semibold text-xl flex flex-col flex-1 gap-5"
        >
          <span>{{ info?.label }}</span>
          <div class="flex items-end">
            <div
              class="w-20 h-0.5 bg-white rounded-md"
              style="height: 2px"
            ></div>
            <div class="flex-1 bg-skyBlue" style="height: 1px"></div>
          </div>
        </div>
        <div class="w-20 h-16 overflow-hidden">
          <div class="w-24 h-16">
            <img class="w-32 h-full" src="@/assets/teach.png" alt="" />
          </div>
        </div>
      </div>
      <div class="flex flex-col text-white gap-6">
        <div
          v-for="item in pageInfoList"
          :key="item?.id"
          class="flex items-start pl-3 gap-5"
          @click="() => handleNavigateToDetail(item?.id,item?.title)"
        >
          <div class="flex flex-col gap-0.2 items-center">
            <div class="text-lg">{{ item.addDate | day("DD") }}</div>
            <div class="text-xs">{{ item.addDate | day("YYYY.MM") }}</div>
          </div>
          <div
            class="flex flex-col gap-2 pb-6"
            style="border-bottom: 2px solid #3663a9"
          >
            <div class="text-base font-semibold">{{ item?.title }}</div>
            <div
              class="text-xs font-normal text-skyBlue pr-3"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
              "
            >
              {{ item?.descripton }}
            </div>
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col items-end py-2 px-3">
        <div
          class="flex cursor-pointer text-white text-xs items-center gap-3"
          @click="handleNavigateToList(info?.id)"
        >
          <span>查看更多</span><span>→</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { array_ } from "../utils";
import mixins from "../hooks";

export default {
  name: "SpecialColumn",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },
  computed: {
    // 展示列表
    pageInfoList() {
      return array_(this.info?.newData?.slice(0, 4));
    },
  },
  methods: {},
};
</script>
<style scoped></style>
